import ReactGA from 'react-ga4';

/**
 * Initialize Google Analytics 4
 * Should be called once in your app initialization
 */
export const initGA4 = () => {
  // Get GA4 Measurement ID from environment variable
  const measurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID;

  if (!measurementId) {
    console.warn('GA4 Measurement ID not found in environment variables');
    return;
  }

  // Only initialize in production or when explicitly enabled
  if (import.meta.env.PROD || import.meta.env.VITE_GA4_DEV === 'true') {
    try {
      ReactGA.initialize(measurementId, {
        gaOptions: {
          anonymizeIp: true, // GDPR-friendly: masks last octet of IP
        },
      });
      console.log('GA4 initialized successfully');
    } catch (err) {
      console.error('Failed to initialize GA4:', err);
    }
  } else {
    console.log('GA4 disabled in development mode');
  }
};

/**
 * Track page views with optional custom parameters
 */
export const trackPageView = (
  path: string,
  title?: string,
  customParams?: Record<string, unknown>
) => {
  if (import.meta.env.PROD || import.meta.env.VITE_GA4_DEV === 'true') {
    ReactGA.send({
      hitType: 'pageview',
      page: path,
      title: title || document.title,
      ...customParams,
    });
  }
};

/**
 * Track custom events
 */
export const trackEvent = (
  action: string,
  category: string = 'engagement',
  label?: string,
  value?: number
) => {
  if (import.meta.env.PROD || import.meta.env.VITE_GA4_DEV === 'true') {
    ReactGA.event({
      action,
      category,
      label,
      value,
    });
  }
};

/**
 * Set user ID for cross-session tracking (use carefully with privacy)
 */
export const setUserID = (userId: string) => {
  if (import.meta.env.PROD || import.meta.env.VITE_GA4_DEV === 'true') {
    ReactGA.set({ user_id: userId });
  }
};
